module.exports = __webpack_public_path__ + "img/pillar-pitcher.23dd633a.png";